import {
  Dropdown,
  PaginatedDropdownList,
  SourcesListListData,
  sourcesListListInfiniteOptions
} from '@crm/api'
import {
  DuplicateAlert,
  InfiniteSelect,
  ResponsibleField
} from '@crm/components'
import { Text } from '@shared/components'
import { useSessionContext } from '@shared/hooks'
import { useLocales } from '@shared/locales'
import { getFullName } from '@shared/utils'
import { Col, Form, Input, Row } from 'antd'
import { FormInstance } from 'antd/lib'
import { useEffect } from 'react'

const OFICIU_SOURCE_NAME = 'Oficiu'

type Props = {
  form: FormInstance
  isEdit?: boolean
  ownerName?: string
  duplicateError?: unknown
  onCloseDuplicate?: () => void
}

export const LeadDetails = ({
  form,
  isEdit,
  ownerName,
  duplicateError,
  onCloseDuplicate
}: Props) => {
  const { t } = useLocales()
  const { user } = useSessionContext()
  const currentUserSsoId = user?.user?.sso_id
  const source = Form.useWatch<{ value: number; label: string }>('source', form)

  const isOficiuSource =
    source?.label?.trim().toLowerCase() === OFICIU_SOURCE_NAME.toLowerCase()

  useEffect(() => {
    if (!isOficiuSource) {
      form.setFieldValue('contract_number', undefined)
    }
  }, [isOficiuSource, form])

  return (
    <>
      <DuplicateAlert error={duplicateError} onClose={onCloseDuplicate} />

      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Text size={16} weight={500}>
            {t('lead.lead_details')}
          </Text>
        </Col>

        <Col span={12}>
          <Form.Item
            name="source"
            label={t('contacts.source')}
            rules={[{ required: true }]}
          >
            <InfiniteSelect<
              SourcesListListData,
              PaginatedDropdownList,
              Dropdown
            >
              labelInValue
              placeholder={t('contacts.source')}
              getQueryFunction={sourcesListListInfiniteOptions}
              baseOptions={{
                query: {
                  preference: source?.value ? [source.value] : undefined
                }
              }}
            />
          </Form.Item>
        </Col>

        {isOficiuSource && (
          <Col span={12}>
            <Form.Item
              name="contract_number"
              label={t('contracts.contract_number')}
            >
              <Input placeholder={t('contracts.contract_number')} />
            </Form.Item>
          </Col>
        )}

        <Col span={12}>
          <Form.Item
            name="owner"
            label={t('contacts.responsible_person')}
            initialValue={isEdit ? undefined : currentUserSsoId}
          >
            <ResponsibleField
              placeholder={t('contacts.responsible_person')}
              preference={currentUserSsoId}
              fallbackName={isEdit ? ownerName : getFullName(user?.user)}
            />
          </Form.Item>
        </Col>

        <Col span={24} className="w-full">
          <Form.Item name="comment" label={t('contacts.comment')}>
            <Input.TextArea rows={4} placeholder={t('contacts.description')} />
          </Form.Item>
        </Col>
      </Row>
    </>
  )
}
